document.addEventListener("DOMContentLoaded", () => {
  // Register gsap plugins
  gsap.registerPlugin(ScrollTrigger, SplitText);

  // Split texts into words (or chars or lines)
  const texts = document.querySelectorAll(".split-text");
  texts.forEach((element) => {
    const split = new SplitText(element, { type: "lines", linesClass: "line" });

    gsap.from(split.lines, {
      scrollTrigger: {
        trigger: element,
        start: "top 90%",
        toggleActions: "play none none reset",
      },
      opacity: 0,
      y: 30,
      ease: "power3.out",
      duration: 0.9,
      stagger: 0.1,
    });
  });

  // Fill Button with orange gradient
  const btns = document.querySelectorAll(".fill-button");

  btns.forEach((btn) => {
    gsap.to(btn, {
      "--fill-x": "0%",
      "--fill-y": "0%",
      duration: 1,
      ease: "power2.out",
      scrollTrigger: {
        trigger: btn,
        start: "top 90%",
        toggleActions: "play none none none",
        once: true,
        onEnter: () => btn.classList.add("filled"),
      },
    });
  });

  // Animate.css animations
  const animateClass = ".animate-element";

  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5,
  };

  function intersectionCallback(entries, observer) {
    entries.forEach((entry) => {
      const className = entry.target.getAttribute("data-animate-type");
      if (entry.isIntersecting) {
        entry.target.classList.add("animated", className);
        observer.unobserve(entry.target);
      }
    });
  }

  const observer = new IntersectionObserver(intersectionCallback, observerOptions);

  function observeElements() {
    const elements = document.querySelectorAll(animateClass);
    elements.forEach((el) => observer.observe(el));
  }

  window.addEventListener("load", (event) => {
    observeElements();
  });

  observeElements();
});
